import { withDatabase } from "@nozbe/watermelondb/DatabaseProvider";
import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import React from "react";
import { compose } from "recompose";
import { default as StockCountModel } from "../../../../utilities/data/model/StockCount";
import { getStockCountItemCountObservables } from "./enhancers";
import { StockCountScreenRenderer } from "./components";
import { useCurrentCountContext } from "../../../../utilities/stock-count/hooks";
import { Button } from "@towersystems/roam-common-native";
import { useTranslation } from "../../../../utilities/i18n";

export const StockCountScreen = (props: any) => {
  const { t } = useTranslation("stock_counts");
  const { navigation } = props;
  const { stockCount } = useCurrentCountContext();

  function handleMoreActionsPress() {
    navigation.navigate("StockCountActionsRootScreen", {
      screen: "StockCountActionsScreen",
      params: {
        stockCountId: stockCount.id,
      },
    });
  }

  React.useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <Button
          label={t("common:actions_button")}
          isAction
          size="compact"
          onPress={handleMoreActionsPress}
        />
      ),
    });
  }, [handleMoreActionsPress]);

  return <StockCountScreenInner stockCount={stockCount} {...props} />;
};

interface EnhanceStockCountScreenProps {
  stockCount: StockCountModel;
}

function getStockCountObservable({
  stockCount,
}: {
  stockCount: StockCountModel;
}) {
  const items = stockCount.items.observe();
  return {
    stockCountLines: items,
    stockCount: stockCount.observe(),
  };
}

export type EnhancedStockCountScreenReturn = ExtractedObservables<
  ReturnType<typeof getStockCountObservable>
>;

export const enhanceStockCountScreen = compose<
  EnhancedStockCountScreenReturn,
  EnhanceStockCountScreenProps
>(
  withDatabase,
  withObservables(["stockCount"], getStockCountObservable),
  withObservables(["stockCount"], getStockCountItemCountObservables),
);

export const StockCountScreenInner = enhanceStockCountScreen(
  // @ts-ignore
  StockCountScreenRenderer,
);
